import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  AdminDocumentTemplate,
  AdminDocumentsPaginatedResponse,
  AdminDocumentTemplateCreatePayload,
  AdminDocumentTemplateFilters,
  AdminDocumentTemplateUpdatePayload,
  AdminDocumentTemplateVersion,
  AdminDocumentVariablesResponse,
} from "~/types/admin/documents";

class AdminDocumentsModule extends HttpFactory {
  async getTemplates(
    filters: AdminDocumentTemplateFilters = {},
  ): Promise<AdminDocumentsPaginatedResponse<AdminDocumentTemplate>> {
    return await this.get(ENDPOINTS.ADMIN.DOCUMENTS.TEMPLATES, filters);
  }

  async getTemplate(templateId: number): Promise<AdminDocumentTemplate> {
    return await this.get(
      `${ENDPOINTS.ADMIN.DOCUMENTS.TEMPLATES}${templateId}/`,
    );
  }

  async createTemplate(
    payload: AdminDocumentTemplateCreatePayload | FormData,
  ): Promise<AdminDocumentTemplate> {
    return await this.post(ENDPOINTS.ADMIN.DOCUMENTS.TEMPLATES, payload);
  }

  async updateTemplate(
    templateId: number,
    payload: AdminDocumentTemplateUpdatePayload,
  ): Promise<AdminDocumentTemplate> {
    return await this.patch(
      `${ENDPOINTS.ADMIN.DOCUMENTS.TEMPLATES}${templateId}/`,
      payload,
    );
  }

  async deleteTemplate(templateId: number): Promise<void> {
    await this.delete(`${ENDPOINTS.ADMIN.DOCUMENTS.TEMPLATES}${templateId}/`);
  }

  async downloadTemplateFile(templateId: number): Promise<Blob> {
    return await this.get(
      `${ENDPOINTS.ADMIN.DOCUMENTS.TEMPLATES}${templateId}/download/`,
      {},
      { responseType: "blob" },
    );
  }

  async uploadTemplateVersion(
    templateId: number,
    payload: FormData,
  ): Promise<AdminDocumentTemplateVersion> {
    return await this.post(
      `${ENDPOINTS.ADMIN.DOCUMENTS.TEMPLATES}${templateId}/upload-version/`,
      payload,
    );
  }

  async listVariables(): Promise<AdminDocumentVariablesResponse> {
    return await this.get(ENDPOINTS.ADMIN.DOCUMENTS.VARIABLES);
  }
}

export default AdminDocumentsModule;
